import { render, staticRenderFns } from "./VWID42026Disclosure.vue?vue&type=template&id=732f7ac2&"
import script from "./VWID42026Disclosure.vue?vue&type=script&lang=js&"
export * from "./VWID42026Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports